module.exports = __webpack_public_path__ + "static/media/Ordenanza 537-2021.5a33d846.pdf";